
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Ertigacabbookinginpune() {



    const cardData =
    {
        keyword: 'Ertiga Cab Booking in Pune  ',
        heading: 'Vedant Travels: Ertiga Cab Booking in Pune ',
        headingDescription: 'Vedant Travels offers Ertiga cab booking in Pune, providing you with a spacious, comfortable, and affordable vehicle for your travel needs. Whether you are planning a family trip, a group outing, or need a reliable car for business purposes, the Ertiga is the ideal choice. With seating for up to 7 passengers, the Ertiga ensures ample space for both passengers and luggage, making it the perfect vehicle for medium-sized groups or family vacations.',

        top: 'Top Places to Visit in Pune with Vedant Travels',

       "topPlaces": [
        {
            "title": "Shaniwar Wada",
            "description": "A historic fort that was once the residence of the Peshwa rulers, Shaniwar Wada is a must-visit for history enthusiasts. The fort features impressive Maratha architecture and offers an engaging light-and-sound show that brings its fascinating history to life."
        },
        {
            "title": "Aga Khan Palace",
            "description": "Built in 1892, the Aga Khan Palace is not only a beautiful structure but also a significant historical site. It was used as a prison during the freedom struggle, and Mahatma Gandhi and his associates were held here. The palace is surrounded by lush gardens, providing a peaceful atmosphere for reflection."
        },
        {
            "title": "Sinhagad Fort",
            "description": "Located 35 km from Pune, Sinhagad Fort is a popular destination for trekkers and history lovers. The fort offers stunning views of the surrounding valleys and is known for its role in Maratha history. It’s a great place for those seeking adventure and historical exploration."
        },
        {
            "title": "Osho Ashram",
            "description": "Situated in Koregaon Park, the Osho Ashram is a globally recognized meditation and spiritual retreat center. Visitors can participate in a variety of meditation sessions and spiritual workshops, making it an ideal spot for relaxation and inner peace."
        },
        {
            "title": "Raja Dinkar Kelkar Museum",
            "description": "The Raja Dinkar Kelkar Museum houses a vast collection of Indian artifacts, including sculptures, musical instruments, and daily-use items from different historical periods. It’s a fascinating stop for anyone interested in India’s cultural heritage."
        },
        {
            "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
            "description": "A beautiful Japanese-inspired garden located in Pune, this garden is perfect for a relaxing stroll. With lush greenery, vibrant flowers, and serene ponds, it offers a peaceful escape from the busy city life."
        },
        {
            "title": "Pashan Lake",
            "description": "Pashan Lake is a serene spot, perfect for nature lovers and birdwatching enthusiasts. Surrounded by lush greenery, it provides a quiet environment for photography, walks, and peaceful reflection."
        },
        {
            "title": "Bund Garden",
            "description": "Bund Garden is a riverside park ideal for a relaxing walk, boating, or picnicking. The tranquil atmosphere and natural beauty make it a lovely spot to unwind and enjoy time with family or friends."
        },
        {
            "title": "Saras Baug",
            "description": "Saras Baug is a popular temple complex in Pune, known for its beautiful Ganesha temple and peaceful gardens. It’s a great place to enjoy a leisurely walk, relax in the gardens, or simply seek spiritual solace."
        },
        {
            "title": "Fergusson College",
            "description": "One of Pune’s oldest and most prestigious educational institutions, Fergusson College is known for its colonial-era architecture and rich academic history. It’s a beautiful campus to explore, showcasing Pune’s educational legacy and architectural beauty."
        }
    ],
    "services": [
        {
            "name": "Ertiga Rent Per Km in Pune",
            "description": "Vedant Travels offers competitive rates for renting an Ertiga per kilometer in Pune. Whether for a local trip or outstation journey, we provide affordable rental options for a comfortable and spacious ride."
        },
        {
            "name": "Ertiga Cab Booking in Pune",
            "description": "Book your Ertiga cab in Pune with Vedant Travels for a smooth and comfortable journey. Our fleet of well-maintained Ertiga vehicles ensures a spacious and enjoyable ride at competitive rates."
        },
        {
            "name": "Book Ertiga Car in Pune",
            "description": "Looking to book an Ertiga car in Pune? Vedant Travels offers easy and reliable booking for your journey. Choose from our well-maintained Ertiga cabs for a comfortable and hassle-free ride."
        },
        {
            "name": "Pune to Outstation Ertiga Cab",
            "description": "For an outstation trip from Pune, choose Vedant Travels' Ertiga cabs for a comfortable and spacious ride. Our reliable service and competitive pricing ensure a smooth journey, whether it's a short or long-distance trip."
        },
        {
            "name": "New Ertiga Cab Booking in Pune",
            "description": "Vedant Travels offers new Ertiga cabs for booking in Pune. Our fleet of brand-new Ertiga vehicles guarantees a comfortable and spacious ride, ensuring a smooth and enjoyable journey."
        },
        {
            "name": "New Ertiga Cab Booking in Pune Contact Number",
            "description": "To book a new Ertiga cab in Pune, contact Vedant Travels at [insert contact number]. Our team is ready to assist you with your booking and ensure a comfortable ride."
        },
        {
            "name": "New Ertiga Cab Booking in Pune Contact Number Hadapsar",
            "description": "For new Ertiga cab bookings in Hadapsar, Pune, contact Vedant Travels at [insert contact number]. We offer reliable and comfortable Ertiga services for your local and outstation journeys."
        },
        {
            "name": "Ertiga Cab Booking in Kharadi",
            "description": "Book your Ertiga cab in Kharadi with Vedant Travels for a smooth and spacious ride. Our well-maintained Ertiga vehicles ensure a comfortable journey at competitive rates."
        },
        {
            "name": "Ertiga Cab Booking in Hinjewadi",
            "description": "For a reliable Ertiga cab service in Hinjewadi, Pune, choose Vedant Travels. We provide well-maintained Ertiga vehicles for local and outstation trips, ensuring comfort and convenience throughout your journey."
        }
    ],


 "tableData": [
    ["Ertiga Rent Per Km in Pune", "Ertiga Cab Booking in Pune"],
    ["Book Ertiga Car in Pune", "Pune to Outstation Ertiga Cab"],
    ["New Ertiga Cab Booking in Pune", "New Ertiga Cab Booking in Pune Contact Number"],
    ["New Ertiga Cab Booking in Pune Contact Number Hadapsar", "Ertiga Cab Booking in Kharadi"],
    ["Ertiga Cab Booking in Hinjewadi", ""]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we understand that punctuality is key when booking an Ertiga cab in Pune. Whether it’s a business trip, family outing, or an airport transfer, we ensure timely pickups and drop-offs for a smooth and stress-free journey."
    },
    {
      "WhyChooseheading": "Comfortable and Spacious Vehicle",
      "WhyChoosedescription": "The Ertiga is a perfect blend of comfort, space, and economy. With its spacious interiors, ample legroom, and excellent air conditioning, it provides a comfortable ride for both short and long-distance trips around Pune."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are experienced and familiar with the roads of Pune and surrounding areas. They are courteous, professional, and ensure a smooth ride in the Ertiga. You can trust them to offer a safe and efficient journey."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Vedant Travels offers competitive and transparent pricing for Ertiga cab bookings in Pune. There are no hidden charges, and our pricing structure is clear, so you know exactly what you’re paying for. We ensure the best value for your money."
    },
    {
      "WhyChooseheading": "Safe and Comfortable Journey",
      "WhyChoosedescription": "Safety is a priority for us. The Ertiga is regularly serviced and equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our professional drivers follow strict safety protocols to ensure your well-being throughout the ride."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether you need an Ertiga cab early in the morning or late at night, Vedant Travels offers 24/7 availability for your convenience. You can book a cab for any time of the day or night, and our customer service team will be happy to assist you."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking an Ertiga cab with Vedant Travels is quick and easy. You can book online via our website or mobile app, or simply call our customer service team for assistance with your booking. We ensure a smooth and efficient booking experience."
    },
    {
      "WhyChooseheading": "Customizable Travel Packages",
      "WhyChoosedescription": "Whether it’s a one-way trip, a sightseeing tour, or a round-trip journey, we offer flexible packages tailored to your needs. Let us know your travel requirements, and we’ll customize the service to ensure you get the best experience."
    }
  ]

    }



    const faqData = [
          {
        id: 1,
        question: 'How can I book an Ertiga cab in Pune?',
        answer: 'You can easily book an Ertiga cab online through our website or mobile app. Alternatively, you can contact our customer service team, and they will assist you with the booking process.',
    },
    {
        id: 2,
        question: 'What is the capacity of the Ertiga?',
        answer: 'The Ertiga is a 7-seater vehicle, making it ideal for family trips, group travel, or airport transfers. It comfortably accommodates passengers along with their luggage.',
    },
    {
        id: 3,
        question: 'Is the Ertiga suitable for long-distance travel in Pune?',
        answer: 'Yes, the Ertiga is well-suited for both short and long-distance travel. Whether you\'re exploring Pune or traveling to nearby cities, the Ertiga offers a smooth and comfortable ride.',
    },
    {
        id: 4,
        question: 'What payment options are available for booking the Ertiga cab?',
        answer: 'We accept multiple payment options, including cash, credit/debit cards, and online payment through our mobile app, making the payment process convenient for you.',
    },
    {
        id: 5,
        question: 'Can I hire the Ertiga for a one-way trip from Pune to Mumbai?',
        answer: 'Yes, you can book the Ertiga for a one-way trip from Pune to Mumbai or vice versa. Simply provide the details of your journey, and we will arrange the cab accordingly.',
    },
    {
        id: 6,
        question: 'Are there any additional charges for the Ertiga cab booking?',
        answer: 'Any additional charges, such as toll fees or extra waiting time, will be communicated to you upfront. We believe in transparent pricing, and there are no hidden charges.',
    },
    {
        id: 7,
        question: 'Can I use the Ertiga for sightseeing in and around Pune?',
        answer: 'Yes, the Ertiga is perfect for sightseeing trips around Pune. Whether you want to visit iconic spots like Shaniwar Wada or explore nearby hill stations, we can customize the journey as per your preferences.',
    },
    {
        id: 8,
        question: 'What is the luggage allowance for the Ertiga cab?',
        answer: 'The Ertiga has ample boot space and can comfortably accommodate standard luggage. If you have additional luggage or special requirements, kindly inform us at the time of booking, and we will make arrangements accordingly.',
    },
    {
        id: 9,
        question: 'Is Vedant Travels available for corporate travel with the Ertiga?',
        answer: 'Yes, we provide Ertiga cabs for corporate travel. Whether it’s for meetings, conferences, or business events, we can provide reliable and comfortable transportation for your corporate needs.',
    },
    {
        id: 10,
        question: 'Why should I choose Vedant Travels for Ertiga cab booking in Pune?',
        answer: 'Vedant Travels is known for its reliability, punctuality, and customer-centric approach. We provide well-maintained vehicles, professional drivers, and affordable pricing, making us the ideal choice for your Ertiga cab booking in Pune.',
    },
];
    
    const testimonials = [
        {
            name: "Mr. Sandeep Rao",
            title: "Family Traveler",
            quote: "I booked an Ertiga for a family trip around Pune, and the experience was fantastic. The vehicle was clean, spacious, and comfortable. The driver was professional, and we had a smooth and enjoyable trip.",
            rating: 5,
        },
        {
            name: "Ms. Meera Gupta",
            title: "Business Traveler",
            quote: "I hired an Ertiga for a business trip, and I was impressed by the punctuality and comfort. The driver was courteous and made sure everything went smoothly. Highly recommended for group travel!",
            rating: 5,
        },
    ];
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga Cab Booking in Pune",
  "image": "https://vedanttravels.in/assets/images/ertiga-cab-booking-in-pune.jpg",
  "description": "Book Ertiga cab in Pune with Vedant Travels for affordable and spacious travel. Ideal for family trips, group travel, and outstation journeys. Clean AC vehicles with courteous and professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4350"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2499",
    "availability": "https://schema.org/InStock",
    "url": "https://vedanttravels.in/ertiga-cab-booking-in-pune"
  }
};



      
   
      


    return (
        <div>
            <Helmet>
  <title>Ertiga Cab Booking in Pune | Spacious & Affordable | Vedant Travels</title>
  <meta 
    name="description" 
    content="Book Ertiga cab in Pune with Vedant Travels for affordable and spacious travel. Ideal for family trips, group travel, and outstation journeys. Clean AC vehicles with courteous and professional drivers." 
  />
  <meta 
    name="keywords" 
    content="Ertiga Cab Booking in Pune, Pune Ertiga Taxi, Rent Ertiga in Pune, 7-Seater Cab Pune, Family Cab Pune, Group Travel Cab Pune, Vedant Travels Ertiga, Outstation Ertiga Cab Pune, AC Ertiga on Hire Pune, Affordable Ertiga Cab Pune, Online Ertiga Booking Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/68.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Ertigacabbookinginpune;